import { render, staticRenderFns } from "./DonationGoals.vue?vue&type=template&id=501c8e37"
import script from "./DonationGoals.vue?vue&type=script&lang=js"
export * from "./DonationGoals.vue?vue&type=script&lang=js"
import style0 from "./DonationGoals.vue?vue&type=style&index=0&id=501c8e37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VDataTable,VIcon,VImg,VSpacer})
